let permissionCodes = new Set()
let superAdmin = false

/**
 * 更新当前后台账号的权限上下文，供页面方法和 v-permission 指令统一使用。
 */
export function setPermissionContext(user) {
    const roleCodes = user?.roleCodes || [user?.roleCode]
    superAdmin = roleCodes.filter(Boolean).includes('SUPER_ADMIN')
    permissionCodes = new Set([
        ...(user?.permissionCodes || []),
        ...(user?.menuPermissionCodes || []),
        ...(user?.buttonPermissionCodes || []),
    ])
}

/** 判断当前账号是否具备单个原子权限。 */
export function hasPermission(code) {
    return Boolean(code) && (superAdmin || permissionCodes.has('*') || permissionCodes.has(code))
}

/** 判断当前账号是否具备给定权限中的任意一个。 */
export function hasAnyPermission(codes = []) {
    return (Array.isArray(codes) ? codes : [codes]).some(hasPermission)
}

/** 判断当前账号是否同时具备给定权限。 */
export function hasAllPermissions(codes = []) {
    return (Array.isArray(codes) ? codes : [codes]).every(hasPermission)
}
